export const mainHeaderEn = {
  'Edit profile': 'Edit profile',
  'Create new board': 'Create new board',
  'Sign Out': 'Sign Out',
  'To create a new board, please enter board name here':
    'To create a new board, please enter board name here',
  Cancel: 'Cancel',
  Create: 'Create',
  'task title': 'Task title',
  'Board title': 'Board title',
  'task description': 'Task description',
  'board description': 'Board description',
};

export const mainHeaderRu = {
  'Edit profile': 'Редактировать профиль',
  'Create new board': 'Создать новую доску',
  'To create a new board, please enter board name here':
    'Чтобы создать новую доску, пожалуйста, введите название доски здесь',
  'Sign Out': 'Выход',
  Cancel: 'Отменить',
  Create: 'Создать',
  'Create new task': 'Добавить новое задание',
  'Please enter task name here': 'Пожалуйста, введите название задания здесь',
  'Please enter board name here': 'Пожалуйста, введите название доски здесь',
  'task title': 'Название задания',
  'board title': 'Название доски',
  'Board title': 'Название доски',
  'task description': 'Описание задания',
  'board description': 'Описание доски',
  'Board description': 'Описание доски',
  'Enter column title': 'Название колонки',
  'About us': 'О нас',
};
